import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    videoFailedInDeviceType: null,
    videoFailedUserNumber: "",
    localVideoTrackPublicationFailed: false,
    videoNotSupported: false,
    forLocalRemoteCheck: false,
    agentVideoSubscriptionFailed: false,
    guestVideoSubscriptionFailed: false,
};

const trackFailedReducerSlice = createSlice({
    name: "trackFailedReducer",
    initialState,
    reducers: {
        setVideoFailedInDeviceType(state, action) {
            state.videoFailedInDeviceType = action.payload;
        },
        setVideoFailedUserNumber(state, action) {
            state.videoFailedUserNumber = action.payload;
        },
        setLocalVideotrackPublicationFailed(state, action) {
            state.localVideoTrackPublicationFailed = action.payload;
        },
        setVideoNotSupported(state, action) {
            state.videoNotSupported = action.payload;
        },
        setForLocalRemoteCheck(state, action) {
            state.forLocalRemoteCheck = action.payload;
        },
        setAgentVideoSubscriptionFailed(state, action) {
            state.agentVideoSubscriptionFailed = action.payload;
        },
        setGuestVideoSubscriptionFailed(state, action) {
            state.guestVideoSubscriptionFailed = action.payload;
        },
        resetTrackFailedReducer() {
            return initialState;
        },
    },
});

export const {
    resetTrackFailedReducer,
    setVideoFailedInDeviceType,
    setVideoFailedUserNumber,
    setLocalVideotrackPublicationFailed,
    setVideoNotSupported,
    setForLocalRemoteCheck,
    setAgentVideoSubscriptionFailed,
    setGuestVideoSubscriptionFailed,
} = trackFailedReducerSlice.actions;

export default trackFailedReducerSlice.reducer;
